import React from "react"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer" style={{ backgroundColor: "rgb(38, 37, 35)" }}>
        <Container fluid={true}>
          <Row>
            <Col md={6}>{new Date().getFullYear()} © Curbstand</Col>
            <Col md={6}>
              <div className="text-sm-end d-none d-sm-block">
                CurbDash
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
